import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import OrcaSecurityShiftLeftMappingForm from "./OrcaSecurityShiftLeftMappingForm";
import { Alert } from "antd";

function OrcaSecurityShiftLeftCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "token",
      label: "Token",
      required: true,
      type: FieldTypes.PASSWORD,
    },
    {
      name: "message",
      type: FieldTypes.LABEL,
      value: (
        <Alert
          type="warning"
          message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."
        />
      ),
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={OrcaSecurityShiftLeftMappingForm}
      initialValue={{ apiEndpoint: "https://app.<region>.orcasecurity.io" }}
    />
  );
}

export default forwardRef(OrcaSecurityShiftLeftCredentialsForm);
